<template>
  <div class="article-contentainer">

    <article-list :article="articleList"></article-list>

    <section class="loading">
      <p
        id="waterfall"
        v-if="!nomore"
      >
        <span @click="getMore()">{{ $t('tag-article.more') }}</span>
      </p>
      <div
        id="waterfall-nomore"
        v-else
      >
        <span class="line"></span>
        <p>已显示全部文章</p>
        <span class="line"></span>
      </div>
    </section>
  </div>
</template>
<script>
import * as api from "~/api/index";
import articleList from "~/components/index/article-list.vue";
export default {
  data() {
    return {
      routerTag: '',
      pageTag: '',
      nomore: true,
      page: 1,
      count: 30

    }
  },
  async asyncData({ app, error, req, store, $axios, route }) {
    const tag = route.params.type
    let articleResult = null,
      memberTagResult = null,
      nomore = false;

    articleResult = await $axios(api.getIndexArticle({ tags: tag, page: 1, count: 30 }))
    return {
      articleList: articleResult && articleResult.result ? articleResult.result : [],
      nomore: articleResult && articleResult.result && articleResult.totalCount > articleResult.result.length ? false : true
    }
  },
  methods: {
    async getMore() {
      let articleResult = null;
      this.page++;
      articleResult = await this.$axios(api.getIndexArticle({ tags: this.routerTag, page: this.page, count: this.count }))
      if (articleResult && articleResult.result) {
        this.articleList = [...this.articleList, ...articleResult.result]
        this.nomore = articleResult.totalCount > this.articleList.length ? false : true
      }

    }
  },
  components: {
    articleList
  }
}
</script>

<style lang="less" scoped>
.article-contentainer {
  .member-tags-content {
    background: #fff;
    width: 100%;
    height: 36px;
    padding-left: 22px;

    span {
      display: flex;
      // flex-flow: row nowrap;
      align-items: center;
      color: #666;
      height: 36px;
      background: #f6f6f6;
      font-size: 14px;
      float: left;
      cursor: pointer;
      &.active {
        font-weight: bolder;
        color: #333333;
      }
      &::after {
        content: '';
        display: inline-block;
        border-right: 1px solid #e8e8e8;
        width: 0;
        height: 14px;
        margin: 0 27px;
      }
    }
    span:nth-child(1) {
      padding-left: 26px;
    }
    span:nth-last-child(1) {
      padding-right: 26px;
      &::after {
        content: '';
        display: none;
      }
    }
  }
}
</style>

